import { axiosInstance } from "./config";


const API = "/admin/login";

export const createLogin = async (data) => {
  const res = await axiosInstance.post(API, data);
  return res.data; // ✅ correct
};

export const getMe = () => {
  return axiosInstance.get("/me");
};